import axios from "axios";

const listCoureurs = {
    namespaced: true,
    state: {
        participants: {},
        searched_participants: [],
        courseFilter: "",
        searchFilter: "",
        sexeFilter: "",
        sortby: "clt",
        page: 1,
        perPage: 30,
        fields: [
            {
                key: "classement",
                sortable: false,
                label: "Scratch",
            },
            {
                key: "dossard",
                sortable: false,
                label: "Dossard",
            },
            {
                key: "itra",
                sortable: false,
                label: "Itra",
            },
            {
                key: "nom",
                sortable: false,
                label: "Nom/Prénom",
            },
            {
                key: "sexe",
                sortable: false,
                label: "Sexe",
            },
            {
                key: "cat",
                sortable: false,
                label: "Cat",
            },
            {
                key: "club",
                sortable: false,
                label: "Club",
            },
            {
                key: "classement_sexe",
                sortable: false,
                label: "Clt Sexe",
            },
            {
                key: "classement_cat",
                sortable: false,
                label: "Clt Cat",
            },
            {
                key: "statut",
                sortable: false,
                label: "Statut",
                class: "align_center",
            },
        ],
    },
    mutations: {
        setParticipants(state, participants) {
            state.participants = participants;
        },
        setSearchedParticipants(state, participants) {
            state.searched_participants = participants;
        },
        setCourseFilter(state, course) {
            state.courseFilter = course;
        },
        setSearchFilter(state, search) {
            state.searchFilter = search;
        },
        setSexeFilter(state, sexe) {
            state.sexeFilter = sexe;
        },
        setSortby(state, sortby) {
            state.sortby = sortby;
        },
        setPage(state, page) {
            state.page = page;
        },
        setPerPage(state, perPage) {
            state.perPage = perPage;
        },
        setFields(state, fields) {
            state.fields = fields;
        },
        resetSearchedParticipants(state) {
            state.searched_participants = [];
        },
    },
    getters: {
        participants(state) {
            return state.participants;
        },
        searched_participants(state) {
            return state.searched_participants;
        },
        courseFilter(state) {
            return state.courseFilter;
        },
        searchFilter(state) {
            return state.searchFilter;
        },
        sexeFilter(state) {
            return state.sexeFilter;
        },
        sortby(state) {
            return state.sortby;
        },
        page(state) {
            return state.page;
        },
        perPage(state) {
            return state.perPage;
        },
        fields(state) {
            return state.fields;
        },
        translated_stats(state) {
            var translated_stats = "";
            if (state.participants.stats_inscriptions) {
                var raw_stats = state.participants.stats_inscriptions.split("-");
                for (var i = 0; i < raw_stats.length; i++) {
                    var raw_item_stat = raw_stats[i].split(":");
                    // Note: On utilisera $t dans le composant pour la traduction
                    if (raw_item_stat[0].includes("Inscrits")) {
                        raw_item_stat[0] = "Inscrits";
                    } else if (raw_item_stat[0].includes("Partis")) {
                        raw_item_stat[0] = "Partis";
                    } else if (raw_item_stat[0].includes("Arrivés")) {
                        raw_item_stat[0] = "Arrivés";
                    } else if (raw_item_stat[0].includes("Abandons")) {
                        raw_item_stat[0] = "Abandons";
                    }
                    translated_stats += raw_item_stat[0] + " : " + raw_item_stat[1];
                    if (i < raw_stats.length - 1) {
                        translated_stats += " - ";
                    }
                }
            }
            return translated_stats;
        },
    },
    actions: {
        async fetchInscriptions({ commit, state, rootState, dispatch }, routeParams = {}) {


            var endpoint = await dispatch("buildEndpoint", null, { root: false });
            try {
                const response = await axios.get(rootState.base_url + endpoint);
                commit("setParticipants", response.data);

                if (state.courseFilter === "") {
                    // Si pas de course sélectionnée, par défaut la première
                    commit("setCourseFilter", response.data.list_courses[0]);
                }

                if (!response.data.list_courses.includes("Hors course")) {
                    // Rajoute choix de course les hors courses
                    response.data.list_courses.push("Hors course");
                }

                if (!response.data.list_parcours[response.data.list_courses[0]].live_en_cours) {
                    // Check si live en cours
                    rootState.live_en_cours = false;
                }

                if (parseInt(response.data.refresh_time_live) !== 0) {
                    // Défini les durées de rafraîchissement
                    commit("set_refresh_time_live", response.data.refresh_time_live, { root: true });
                }

                if (parseInt(response.data.refresh_time_carte) !== 0) {
                    commit("set_refresh_time_carte", response.data.refresh_time_carte, { root: true });
                }

                if (response.data.timestamp_depart) {
                    // Données nécessaires au spinner_live pour afficher temps de course
                    rootState.date_selected_course = response.data.timestamp_depart.date_course;
                    rootState.heure_selected_course = response.data.timestamp_depart.heure_depart;
                    rootState.fin_selected_course = response.data.timestamp_depart.course_finie;
                }

                dispatch("countdownRefresh");
                commit("unsetLoading", null, { root: true });
            } catch (error) {
                console.error("Erreur lors de la récupération des inscriptions:", error);
                commit("unsetLoading", null, { root: true });
            }
        },

        async searchInscriptions({ commit, state, rootState, rootGetters, dispatch }) {

            if (state.searchFilter.length < 1) {
                commit("resetSearchedParticipants");
                return;
            }

            // Si admin, ne pas remplir searched_participants
            /* const isAdmin = rootGetters["authAdmin/hasAdminRights"];
            if (isAdmin) {
                commit("resetSearchedParticipants");
                return;
            } */

            var endpoint = await dispatch("buildSearchEndpoint", null, { root: false });
            try {
                const response = await axios.get(rootState.base_url + endpoint);
                commit("setSearchedParticipants", response.data);
                commit("unsetLoading", null, { root: true });
            } catch (error) {
                console.error("Erreur lors de la recherche:", error);
                commit("unsetLoading", null, { root: true });
            }
        },

        buildSearchEndpoint({ state, rootState }) {

            var url = "/live/search.php?id=" + rootState.module.id + "&id_live=" + rootState.module.id_live;

            if (state.searchFilter != "") {
                url += "&search=" + state.searchFilter;
            }

            return url;
        },

        buildEndpoint({ state, rootState, rootGetters }) {
            // Construit l'endpoint en fonction des filtres de l'utilisateur

            var url = "/live/get.php?id=" + rootState.module.id;

            // Inclure searchFilter uniquement si l'utilisateur est admin
            const isAdmin = rootGetters["authAdmin/hasAdminRights"];
            if (isAdmin && state.searchFilter != "") {
                url += "&search=" + state.searchFilter;
            }

            if (state.courseFilter != "") {
                url += "&course=" + encodeURIComponent(state.courseFilter);
            }
            if (state.sexeFilter != "") {
                url += "&sexe=" + state.sexeFilter;
            }
            if (state.sortby != "clt") {
                url += "&sortby=" + state.sortby;
            }
            url += "&page=" + (state.page - 1);

            return url;
        },

        async changeCoureurAbandon({ dispatch, rootState }, coureur) {
            let data = {
                id_module: rootState.module.id,
                id_live: coureur.id_live,
                dossard: coureur.dossard,
                type_bouton: "abandon",
                nouvelle_valeur: coureur.abandon,
            };
            try {
                await axios.post(rootState.base_url + "/pc_course/statut_coureur/post.php", data);
                dispatch("fetchInscriptions");
            } catch (error) {
                console.error("Erreur lors du changement d'abandon:", error);
            }
        },

        async changeCoureurDisqualifie({ dispatch, rootState }, coureur) {
            let data = {
                id_module: rootState.module.id,
                id_live: coureur.id_live,
                dossard: coureur.dossard,
                type_bouton: "disqualifie",
                nouvelle_valeur: coureur.disqualifie,
            };

            try {
                await axios.post(rootState.base_url + "/pc_course/statut_coureur/post.php", data);
                dispatch("fetchInscriptions");
            } catch (error) {
                console.error("Erreur lors du changement de disqualification:", error);
            }
        },

        countdownRefresh({ dispatch, commit, rootState }) {
            if (!rootState.live_en_cours) {
                commit("clearRefreshIntervals", null, { root: true });
                return;
            }
            var intervalObject = setInterval(function () {
                commit("clearRefreshIntervals", null, { root: true });
                dispatch("fetchInscriptions");
            }, rootState.refresh_time_live);
            rootState.refreshIntervals.push(intervalObject);
        },

        view_adapter_pc_course({ commit, state }) {
            // Si vue pc course, change les champs du tableau
            let fields = [...state.fields];
            fields.splice(6, 1);
            let abandon_col = {
                key: "abandon",
                sortable: false,
                label: "Abandon",
            };
            let disqualifie_col = {
                key: "disqualifie",
                sortable: false,
                label: "Disqualifié",
            };
            fields.splice(fields.length - 1, 0, abandon_col, disqualifie_col);
            commit("setFields", fields);
        },

        view_adapter_MERIB22_KV({ commit, state }) {
            // Si vue MERIB22 KV, change les champs du tableau
            let fields = [...state.fields];
            let heure_depart_col = {
                key: "heure_depart_coureur",
                sortable: false,
                label: "Heure départ",
            };
            fields.splice(fields.length - 1, 0, heure_depart_col);
            commit("setFields", fields);
        },

        unset_view_adapter_MERIB22_KV({ commit, state }) {
            let fields = [...state.fields];
            for (let i = 0; i < fields.length; i++) {
                if (fields[i].key === "heure_depart_coureur") {
                    fields.splice(i, 1);
                    break;
                }
            }
            commit("setFields", fields);
        },

        view_adapter_BONETTE23({ commit, state }) {
            let fields = [...state.fields];
            for (let i = 0; i < fields.length; i++) {
                if (fields[i].key === "cat") {
                    fields.splice(i, 1);
                    break;
                }
            }
            commit("setFields", fields);
        },
    },
};

export default listCoureurs;

